<template>
  <div class="history-prize-page">
    <div class="nav">
      <!-- <div class="title bc_default">
        搜索条件
        <span>彩种</span>
        <DropDownMenu :dropList="gameList" v-model="choiceOption" />
      </div> -->
      <div class="content">
        <DropDownMenu :dropList="gameList" v-model="choiceOption" />
        <div @click="handleSearch" class="btn primary">查询</div>
      </div>
    </div>
    <table class="history-prize-table" cellspacing="0" cellpadding="0">
      <colgroup>
        <col style="width: 25%" />
        <col style="width: 25%" />
        <col style="width: 40%" />
        <col style="width: 10%" />
      </colgroup>
      <thead>
        <tr>
          <th>期数日期</th>
          <th>期号</th>
          <th>开奖号码</th>
          <th>总和</th>
          <!-- <th rowspan="2">合值</th>
          <th rowspan="2">大小</th>
          <th rowspan="2">单双</th> -->
        </tr>
        <!-- <tr>
          <th>第1球</th>
          <th>第2球</th>
          <th>第3球</th>
          <th>第4球</th>
          <th>第5球</th>
        </tr> -->
      </thead>
      <tbody>
        <tr v-for="(item, index) in list" :key="index">
          <td>{{ item.timeStamp | timeFormate }}</td>
          <td>{{ item.qihao }}</td>
          <td style="display: flex; align-items: center">
            <div style="margin: 0 5px" :class="'ball ball' + item.q1"></div>
            <div style="margin: 0 5px" :class="'ball ball' + item.q2"></div>
            <div style="margin: 0 5px" :class="'ball ball' + item.q3"></div>
            <div style="margin: 0 5px" :class="'ball ball' + item.q4"></div>
            <div style="margin: 0 5px" :class="'ball ball' + item.q5"></div>
          </td>
          <td>
            <span
              style="margin: 0 5px"
              :class="[
                item.q1 * 1 +
                  item.q2 * 1 +
                  item.q3 * 1 +
                  item.q4 * 1 +
                  item.q5 * 1 >=
                23
                  ? 'active-text'
                  : '',
              ]"
            >
              {{
                item.q1 * 1 +
                item.q2 * 1 +
                item.q3 * 1 +
                item.q4 * 1 +
                item.q5 * 1
              }}
            </span>
            <span
              style="margin: 0 5px"
              :class="[
                item.q1 * 1 +
                  item.q2 * 1 +
                  item.q3 * 1 +
                  item.q4 * 1 +
                  item.q5 * 1 >=
                23
                  ? 'active-text'
                  : '',
              ]"
            >
              {{
                item.q1 * 1 +
                  item.q2 * 1 +
                  item.q3 * 1 +
                  item.q4 * 1 +
                  item.q5 * 1 >=
                23
                  ? "大"
                  : "小"
              }}
            </span>
            <span
              style="margin: 0 5px"
              :class="[
                (item.q1 * 1 +
                  item.q2 * 1 +
                  item.q3 * 1 +
                  item.q4 * 1 +
                  item.q5 * 1) %
                  2 ==
                0
                  ? 'active-text'
                  : '',
              ]"
            >
              {{
                (item.q1 * 1 +
                  item.q2 * 1 +
                  item.q3 * 1 +
                  item.q4 * 1 +
                  item.q5 * 1) %
                  2 ==
                0
                  ? "双"
                  : "单"
              }}</span
            >
          </td>
        </tr>
      </tbody>
    </table>
    <Paging
      class="pagging center"
      :current_page="current_page"
      :last_page="last_page"
      :total="total"
      @jumper="(val) => (current_page = val)"
      @pre="pre()"
      @next="next()"
      @goFirst="firstPage()"
      @goLast="lastPage()"
    />
  </div>
</template>

<script>
import DropDownMenu from "@/components/DropDownMenu";
import Paging from "@/components/Paging";
export default {
  data() {
    return {
      choiceOption: "hn5fc",
      gameList: [],
      list: [],
      current_page: 1,
      last_page: 1,
      total: 0,
      limit: 15,
    };
  },
  props: ["initFinished"],
  watch: {
    initFinished() {
      this.initData();
    },
    current_page() {
      this.getList();
    },
  },
  mounted() {
    this.initData();
  },
  components: {
    DropDownMenu,
    Paging,
  },
  methods: {
    initData() {
      if (this.initFinished) {
        this.computedGameList();
        this.getList();
      }
    },
    handleSearch() {
      this.current_page = 1;
      this.initData();
    },
    async getList() {
      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
        code: this.$store.state.gameInfo[0].code,
        limit: this.limit,
        page: this.current_page,
      };
      let result = await this.$http.postAxiosMethod("/user/openinfomore", data);
      if (result.code == 0) {
        this.list = result.data;
        this.last_page = Math.ceil((result.count || 0) / this.limit);
        this.total = result.count;
      }
    },
    computedGameList() {
      this.$store.state.gameInfo.forEach((element) => {
        this.gameList.push({
          label: element.gameName,
          value: element.code,
        });
      });
    },
    firstPage() {
      this.current_page = 1;
    },
    pre() {
      if (this.current_page > 1) {
        this.current_page--;
      }
    },
    next() {
      if (this.current_page < this.last_page) {
        this.current_page++;
      }
    },
    lastPage() {
      this.current_page = this.last_page;
    },
  },
};
</script>

<style lang="scss" scoped>
.history-prize-page {
  margin-bottom: 15px;
  background: var(--new-bg-white);
  .nav {
    // border: 1px solid var(--primary-bg-color);
    .title {
      // margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 14px 0 0;
      height: 30px;
      font-size: 14px;
      color: #fff;
      & > span {
        margin: 0 15px;
      }
      .search {
        margin-left: 45px;
        width: 60px;
        height: 25px;
        background: linear-gradient(90deg, #54aff3, #2992e1, #1082d7);
        border-radius: 2px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .content {
      display: flex;
      padding: 5px 20px;
      background: #fff;
      .btn {
        margin-left: 28px;
      }
      ::v-deep {
        .drop-down-menu {
          width: 120px;
        }
      }
    }
  }
  .history-prize-table {
    width: 100%;
    font-size: 14px;
    // background: new(--new-bg-white);
    thead {
      background: var(--new-bg-table-header-main);
      th {
        padding: 0 20px;
        height: 40px;
        line-height: 40px;
        text-align: left;
        color: var(--new-text-info);
        font-weight: bold;
      }
    }
    tbody {
      tr {
        // &:nth-child(n) {
        //   background: #fff;
        // }
        // &:nth-child(2n) {
        //   background: #f0f0f0;
        // }

        td {
          padding: 0 20px;
          height: 30px;
          line-height: 30px;
          // text-align: center;
          font-size: 12px;
          border-bottom: 1px solid var(--new-border);
          // div {
          //   margin: auto;
          // }
        }
      }
    }
  }
  .paging {
    // margin-top: 10px;
  }
}
</style>
